import { useParams } from "infrastructure/router";
import { Filters } from "consts/onboarding";
import { useTypedSelector } from "hooks";
import { selectApplicationById } from "features/onboarding/selectors";
import { disableCta } from "features/onboarding/helpers";
import { ReviewableFormInput, type ReviewableFormInputProps } from "ui/forms/formik-elements";

const OnboardingReviewableFormInput = (props: ReviewableFormInputProps) => {
    const params = useParams();

    const application = useTypedSelector(selectApplicationById(`${params[Filters.pki]}`));

    return (
        <ReviewableFormInput
            {...props}
            disabled={disableCta(application?.status)}
        />
    );
};

export default OnboardingReviewableFormInput;
